<template>
  <div>
    <div class="tw-mb-2 tw-font-semibold">{{ label }}</div>
    <div v-show="loading" class="sr-drop-loading">
      <v-progress-circular :size="35" color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-show="!loading" class="sr-drop-wrapper" @click="$refs.input.click()" @dragover.prevent @drop.prevent="add">
      <div class="sr-drop">
        <span v-if="files.length <= 0" class="sr-drop-label">
          {{ $t("common.form.drag_and_drop.label") }}
        </span>

        <ul>
          <li v-for="(file, i) in files" :key="i" class="tw-flex tw-justify-between tw-items-center">
            <span>{{ file.name }} ({{ file.size | prettyBytes }})</span>
            <v-btn icon small @click.stop="remove(file)">
              <v-icon small>fa-times</v-icon>
            </v-btn>
          </li>
        </ul>

        <input v-show="false" ref="input" multiple name="files[]" type="file" @change="addFromInput" />

        <div v-if="message.length > 0">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Types as TypesSnackbar } from "../../../store/modules/snackbar"

export default {
  name: "DragAndDropField",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    mime: {
      type: Array,
      default: () => [],
    },
    extensions: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    message: "",
    files: [],
  }),
  methods: {
    addFromInput(e) {
      this.clearMessage()

      let droppedFiles = e.target.files
      if (!droppedFiles) return // this tip, convert FileList to array
      ;[...droppedFiles].forEach(f => {
        this.files.push(f)
      })

      this.verifyFilesExtension()
      this.verifyFilesSize()

      this.$emit("input", this.files)
    },
    add(e) {
      this.clearMessage()

      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return // this tip, convert FileList to array
      ;[...droppedFiles].forEach(f => {
        this.files.push(f)
      })

      this.verifyFilesExtension()
      this.verifyFilesSize()

      this.$emit("input", this.files)
    },
    clearMessage() {
      this.message = ""
    },
    verifyFilesExtension() {
      if (this.mime.length <= 0) {
        return
      }
      this.files = this.files.filter(file => {
        if (this.extensions.includes(file.name.slice(-3))) {
          return true
        }
        if (this.mime.includes(file.type)) {
          return true
        }
        this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
          lines: this.$t("common.form.drag_and_drop.type_error", {
            type:
              this.mime.length > 0
                ? this.mime.map(m => m.substring(m.indexOf("/") + 1, m.length)).toString()
                : this.extensions.toString(),
          }),
          config: { timeout: 1000 * 6, color: "error" },
        })
      })
    },
    verifyFilesSize() {
      if (this.size.length <= 0) {
        return
      }

      let divider
      const sizeLetter = this.size.slice(-1).toUpperCase()
      const size = Number(this.size.slice(0, -1))

      if (sizeLetter === "B") {
        divider = 1
      } else if (sizeLetter === "K") {
        divider = 1000
      } else if (sizeLetter === "M") {
        divider = 1e6
      } else if (sizeLetter === "G") {
        divider = 1e9
      } else {
        divider = 1
      }

      this.files = this.files.filter(file => {
        if (size > file.size / divider) {
          return true
        }

        this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
          lines: this.$t("common.form.drag_and_drop.size_error"),
          config: { timeout: 1000 * 6, color: "error" },
        })
      })
    },
    remove(file) {
      this.files = this.files.filter(f => {
        return f !== file
      })

      this.$emit("input", this.files)
    },
  },
}
</script>
